<template>
  <qx-card-form title="发货信息">
    <qx-custom-form :noSubBtn="true"
                    ref="baseForm"
                    :formData="baseForm"
                    labelWidth="120px">
      <section slot="customerInfo"
               slot-scope="prop">
        <ChooseCustomer :isRadio="true"
                        :isInput="true"
                        v-model="prop.form.customerInfo"
                        :otherSearchData="{ state: 1, status: 2 }"
                        @change="onChangeCustomer">
          <span slot="isInputTip"
                class="fix-position">
            <span class="primary cur"
                  @click="toAddCustomer">新增</span>
          </span>
        </ChooseCustomer>
      </section>
      <span slot="sourceAddressNameTip"
            class="fix-position">
        <span class="primary cur"
              @click="toAddNewAddress('0')">新增</span>
      </span>
    </qx-custom-form>
    <button @click="getDataTest"
            class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import ChooseCustomer from 'components/choose/customer';
import {
  cityAddressQueryPage,
} from 'api/distribution';
export default {
  components: {
    ChooseCustomer,
  },
  data () {
    return {
      otherFormData: {
        orderSts: -1,
        orderState: -1,
      },
      baseForm: {
        orgIdOptions: [],
        sourceAdderssNameOptions: [],
        inline: true,
        form: [
          {
            label: '客户名称',
            value: 'customerInfo',
            default: {},
            slot: true,
          },
          {
            label: '联系人',
            value: 'lineName',
            placeholder: '请输入联系人',
            type: 'input',
            disabled: true,
          },
          {
            label: '联系人电话',
            value: 'lineTel',
            placeholder: '请输入联系人电话',
            type: 'input',
            disabled: true,
          },
          {
            label: '下单时间',
            value: 'orderTime',
            placeholder: '请输入下单时间',
            type: 'date',
            attr: {
              type: 'datetime',
              time: '00:00:00',
              format: 'yyyy-MM-dd HH:mm',
              valueFormat: 'yyyy-MM-dd HH:mm',
            },
          },
          {
            label: '提货时间',
            value: 'deliveryTime',
            placeholder: '请输入提货时间',
            type: 'time',
            attr: {
              format: 'HH:mm',
            },
            remark: '当天下单第二天提货',
          },
          {
            label: '出发地名称',
            value: 'sourceAddressName',
            placeholder: '请输入出发地名称',
            type: 'el-autocomplete',
            valueKey: 'addressName',
            querySearchAsync: (queryString, cb) => {
              let resInfo = [];

              const customerInfo = this.$refs.baseForm.getVal('customerInfo');
              let customerId = '';
              if (customerInfo && customerInfo.customerId) {
                customerId = customerInfo.customerId;
              }

              if (queryString && queryString.length) {
                cityAddressQueryPage({
                  rows: 10000,
                  addressType: 0,
                  customerId,
                }).then((res) => {
                  if (res && res.items && res.items.length) {
                    resInfo = res.items.filter((item) => item.addressName.includes(queryString));
                  }
                  cb(resInfo);
                });
              } else {
                cityAddressQueryPage({
                  rows: 10000,
                  addressType: 0,
                  customerId,
                }).then((res) => {
                  if (res && res.items && res.items.length) {
                    resInfo = res.items;
                  }
                  cb(resInfo);
                });
              }
            },
            onSelect: async (item) => {
              if (item) {
                this.$refs.baseForm.setVal('sourceAddressDtl', item.addressDtl);
              }
            },
          },
          {
            label: '详细地址',
            value: 'sourceAddressDtl',
            placeholder: '请输入详细地址',
            type: 'input',
            disabled: true,
          },
        ],
        rules: {
          customerInfo: [
            { required: true, message: '请输入客户名称', trigger: 'submit' },
            {
              validator: (rule, value, callback) => this.checkObjEmpty(rule, value, callback, '请输入客户名称'),
              trigger: 'submit',
            },
          ],
          orderTime: [
            { required: true, message: '请输入下单时间', trigger: 'blur' },
          ],
          deliveryTime: [
            { required: true, message: '请输入提货时间', trigger: 'blur' },
          ],
          sourceAddressName: [
            { required: true, message: '请输入出发地名称', trigger: 'submit' },
          ],
          sourceAddressDtl: [
            { required: true, message: '请输入详细地址', trigger: 'submit' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      const formData = await this.sub();
      console.log(formData);
    },

    onChangeCustomer (item) {
      if (item) {
        this.$refs.baseForm.setVal('lineName', item.lineName);
        this.$refs.baseForm.setVal('lineTel', item.linePhone);
      }
    },

    // 跳转到客户档案新增
    toAddCustomer () {
      this.jump({
        label: '新增客户',
        url: `/manage/archives/customer/archives/edit?id=&fromPage=customerOrder&fromPageLabel=${encodeURIComponent('新增客户订单')}`,
        full: true,
      });
    },

    toAddNewAddress (addressType) {
      const customerInfo = this.$refs.baseForm.getVal('customerInfo');
      if (customerInfo && customerInfo.customerId) {
        sessionStorage.setItem('customerId', customerInfo.customerId);
      }
      sessionStorage.setItem('addressType', addressType);
      this.jump({
        label: '新增地址档案',
        url: '/manage/distribution/addressArchives/edit?id=',
      });
    },

    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        delete formData.customerInfo;
        if (!formData.customerId) {
          this.$message.error('当前客户不存在，请点击新增前往客户档案新增客户');
          formData = null;
        }
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (formData.customerInfo) {
          formData.customerName = formData.customerInfo.customerName;
          formData.customerId = formData.customerInfo.customerId;
        }
        formData.orderTime = this.formatDate(formData.orderTime, 4);
        formData.deliveryTime = this.formatDate(formData.deliveryTime, 2);
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async init (data = {}) {
      // 如果有 customerId，应该是新增完客户档案返回来的，自动填入
      if (sessionStorage.getItem('customerId')) {
        const customerId = sessionStorage.getItem('customerId');
        // 马上清空，这样下次就不会重复获取
        sessionStorage.removeItem('customerId');
        const customerInfo = await this.getCustomerId(customerId);
        data.customerInfo = {
          customerName: customerInfo.customerName || '',
          customerId: customerInfo.customerId || '',
        };
      }
      // 如果没有定义，补充定义一下
      if (!data.customerInfo) {
        data.customerInfo = {};
      }
      // 如果有缓存数据，使用缓存的数据替换
      if (data.customerId) {
        data.customerInfo.customerId = data.customerId;
      }
      if (data.customerName) {
        data.customerInfo.customerName = data.customerName;
      }

      if (!data.orderTime) {
        data.orderTime = this.formatDate(new Date(), 4);
      } else {
        if (typeof data.orderTime === 'number') {
          data.orderTime = this.formatDate(data.orderTime, 4);
        }
      }

      if (!data.deliveryTime) {
        data.deliveryTime = '';
      } else {
        data.deliveryTime = new Date('2020-10-10 ' + data.deliveryTime + ':00');
      }

      this.$refs.baseForm.setVal(data);
      this.setFormVal(this.otherFormData, data);
    },
  },
};
</script>

<style scoped lang="scss">
.fix-position {
  position: relative;
  z-index: 1;
  .cur {
    position: absolute;
    left: 8px;
    white-space: nowrap;
  }
}
</style>
